import React from 'react';
import { ForgeList, ForgeListItem, ForgeToolbar, ForgeIcon } from '@tylertech/forge-react';
import PropTypes from 'prop-types';
import { BACK } from '../../../static/keyWords.js';

const SidePanelBarButton = ({ settingsPanelIsOpen, buttonLabel, onClick, slot, icon }) => {
  return (
    <ForgeToolbar
      no-padding
      slot={slot}
      style={{ display: buttonLabel === BACK ? (settingsPanelIsOpen ? 'block' : 'none') : settingsPanelIsOpen ? 'none' : 'block' }}
      inverted={settingsPanelIsOpen ? 'false' : 'true'}
    >
      <ForgeList navlist slot="center" style={{ width: '100%' }}>
        <ForgeListItem key="back" className="clickable" onClick={onClick}>
          <ForgeIcon external externalType="all" slot="leading" name={icon} />
          <button>{buttonLabel}</button>
        </ForgeListItem>
      </ForgeList>
    </ForgeToolbar>
  );
};

SidePanelBarButton.propTypes = {
  settingsPanelIsOpen: PropTypes.bool,
  buttonLabel: PropTypes.string,
  onClick: PropTypes.func,
  slot: PropTypes.string,
  icon: PropTypes.string,
};

export default SidePanelBarButton;
